/* Love U Forever — Main Theme JS */

// After newsletter signup Shopify reloads with ?customer_posted=true — scroll to top and clean URL
(function () {
  if (window.location.search.indexOf('customer_posted=true') !== -1) {
    window.scrollTo(0, 0);
    if (history.replaceState) history.replaceState(null, '', window.location.pathname);
  }
})();

// Mobile nav
const hamburger = document.getElementById('nav-hamburger');
const navOverlay = document.getElementById('nav-overlay');
const overlayClose = document.getElementById('overlay-close');

if (hamburger && navOverlay) {
  hamburger.addEventListener('click', () => {
    navOverlay.classList.add('open');
    hamburger.setAttribute('aria-expanded', 'true');
    document.body.style.overflow = 'hidden';
  });
}

if (overlayClose && navOverlay) {
  overlayClose.addEventListener('click', () => {
    navOverlay.classList.remove('open');
    hamburger && hamburger.setAttribute('aria-expanded', 'false');
    document.body.style.overflow = '';
  });
}

// Close overlay on ESC
document.addEventListener('keydown', (e) => {
  if (e.key === 'Escape' && navOverlay && navOverlay.classList.contains('open')) {
    navOverlay.classList.remove('open');
    hamburger && hamburger.setAttribute('aria-expanded', 'false');
    document.body.style.overflow = '';
  }
});

// Header scroll state
const header = document.getElementById('header');
if (header) {
  window.addEventListener('scroll', () => {
    header.classList.toggle('scrolled', window.scrollY > 10);
  }, { passive: true });
}

// Real-time clock
function formatClock(dateStr) {
  const dt = new Date(dateStr);
  const days = ['SUN','MON','TUE','WED','THU','FRI','SAT'];
  const months = ['JAN','FEB','MAR','APR','MAY','JUN','JUL','AUG','SEP','OCT','NOV','DEC'];
  const day = days[dt.getDay()];
  const date = String(dt.getDate()).padStart(2, '0');
  const month = months[dt.getMonth()];
  const year = dt.getFullYear();
  let hours = dt.getHours();
  const mins = String(dt.getMinutes()).padStart(2, '0');
  const ampm = hours >= 12 ? 'PM' : 'AM';
  hours = hours % 12 || 12;
  return `${date} ${month} ${year} · ${hours}:${mins} ${ampm} PST`;
}

function updateClock() {
  const clockEls = document.querySelectorAll('[data-luf-clock]');
  if (!clockEls.length) return;

  fetch('https://worldtimeapi.org/api/timezone/America/Los_Angeles')
    .then(r => r.json())
    .then(data => {
      const str = formatClock(data.datetime);
      clockEls.forEach(el => { el.textContent = str; });
    })
    .catch(() => {
      // Fallback to local time
      const now = new Date();
      const str = formatClock(now.toISOString());
      clockEls.forEach(el => { el.textContent = str; });
    });
}

if (document.querySelector('[data-luf-clock]')) {
  updateClock();
  setInterval(updateClock, 60000);
}

// Quantity stepper
document.addEventListener('click', (e) => {
  const btn = e.target.closest('.qty-btn[data-action]');
  if (!btn) return;
  const wrap = btn.closest('.quantity-wrap');
  const input = wrap && wrap.querySelector('.qty-input');
  if (!input) return;
  let val = parseInt(input.value) || 1;
  if (btn.dataset.action === 'minus') val = Math.max(1, val - 1);
  if (btn.dataset.action === 'plus') val += 1;
  input.value = val;
});

// Variant pill selection
document.addEventListener('click', (e) => {
  const pill = e.target.closest('.option-pill');
  if (!pill || pill.classList.contains('unavailable')) return;

  const group = pill.closest('.option-pills');
  if (!group) return;

  group.querySelectorAll('.option-pill').forEach(p => p.classList.remove('selected'));
  pill.classList.add('selected');

  // Sync hidden select
  const optionName = group.dataset.option;
  const select = document.querySelector(`select[data-option="${optionName}"]`);
  if (select) {
    select.value = pill.dataset.value;
    select.dispatchEvent(new Event('change'));
  }

  // Update selected label
  const label = group.closest('.option-group') && group.closest('.option-group').querySelector('.option-label span');
  if (label) label.textContent = pill.dataset.value;

  updateVariant();
});

function updateVariant() {
  const allSelects = document.querySelectorAll('.product-form select[data-option]');
  if (!allSelects.length) return;

  const selectedValues = [...allSelects].map(s => s.value);

  const variantData = document.querySelector('[data-variants]');
  if (!variantData) return;

  let variants;
  try {
    variants = JSON.parse(variantData.dataset.variants);
  } catch(e) { return; }

  const matched = variants.find(v => {
    const opts = [v.option1, v.option2, v.option3].filter(Boolean);
    return opts.every((opt, i) => opt === selectedValues[i]);
  });

  if (!matched) return;

  // Update hidden ID
  const idInput = document.querySelector('.product-form input[name="id"]');
  if (idInput) idInput.value = matched.id;

  // Update price display
  const priceEl = document.querySelector('.product-info__price');
  if (priceEl) {
    const price = (matched.price / 100).toFixed(2);
    const compareAt = matched.compare_at_price ? (matched.compare_at_price / 100).toFixed(2) : null;
    if (compareAt && matched.compare_at_price > matched.price) {
      priceEl.innerHTML = `<s>$${compareAt}</s> <span class="price-sale">$${price}</span>`;
    } else {
      priceEl.innerHTML = `<span class="price-current">$${price}</span>`;
    }
  }

  // Update ATC button
  const atcBtn = document.getElementById('main-atc-btn');
  if (atcBtn) {
    atcBtn.textContent = matched.available ? 'ADD TO CART' : 'SOLD OUT';
    atcBtn.disabled = !matched.available;
  }
}

// Product thumbnail swap + preload + lightbox
(function () {
  const thumbs = document.querySelectorAll('.product-img-grid-item');
  const mainImg = document.getElementById('main-product-image');

  // Preload all product images immediately so thumbnail swaps are instant
  if (thumbs.length) {
    thumbs.forEach(thumb => {
      const src = thumb.dataset.full;
      if (src) { const img = new Image(); img.src = src; }
    });

    thumbs.forEach(thumb => {
      thumb.addEventListener('click', () => {
        const fullSrc = thumb.dataset.full;
        if (!mainImg || !fullSrc) return;
        mainImg.src = fullSrc;
        mainImg.srcset = '';
        thumbs.forEach(t => t.classList.remove('active'));
        thumb.classList.add('active');
      });
    });
  }

  // Lightbox
  const lightbox = document.getElementById('product-lightbox');
  const lightboxImg = document.getElementById('lightbox-img');
  const lightboxClose = document.getElementById('lightbox-close');
  if (!mainImg || !lightbox) return;

  function openLightbox() {
    lightboxImg.src = mainImg.src;
    lightbox.classList.add('open');
    document.body.style.overflow = 'hidden';
  }
  function closeLightbox() {
    lightbox.classList.remove('open');
    document.body.style.overflow = '';
  }

  mainImg.addEventListener('click', openLightbox);
  lightboxClose.addEventListener('click', closeLightbox);
  lightbox.addEventListener('click', e => { if (e.target === lightbox) closeLightbox(); });
  document.addEventListener('keydown', e => {
    if (e.key === 'Escape' && lightbox.classList.contains('open')) closeLightbox();
  });
})();

// Cart item removal (AJAX)
document.addEventListener('click', (e) => {
  const btn = e.target.closest('.cart-item__remove');
  if (!btn) return;
  const line = btn.dataset.line;
  if (!line) return;
  fetch('/cart/change.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ line: parseInt(line), quantity: 0 })
  })
  .then(() => window.location.reload())
  .catch(() => window.location.reload());
});

// Cart qty change — auto submit
document.addEventListener('change', (e) => {
  if (e.target.matches('[name="updates[]"]')) {
    e.target.closest('form') && e.target.closest('form').submit();
  }
});
